export const INTEGRATION_NAMES = {
  ALOHA: 'aloha',
  THERAPY_PMS: 'amrex',
  VIREO: 'vireo',
  LUMARY: 'lumary',
  BOOST: 'boost',
  CAMBER: 'camber',
};

export const HUMANIZED_INTEGRATION_NAMES = {
  [INTEGRATION_NAMES.ALOHA]: 'AlohaABA',
  [INTEGRATION_NAMES.VIREO]: 'Vireo',
  [INTEGRATION_NAMES.LUMARY]: 'Lumary',
  [INTEGRATION_NAMES.BOOST]: 'Boost',
  [INTEGRATION_NAMES.CAMBER]: 'Camber',
  [INTEGRATION_NAMES.THERAPY_PMS]: 'TherapyPMS',
};

/**
 * Integrations existed before API/v2 implementation (they are not based on the API/v2).
 */
export const BASE_INTEGRATIONS = [
  INTEGRATION_NAMES.ALOHA,
  INTEGRATION_NAMES.VIREO,
  INTEGRATION_NAMES.THERAPY_PMS,
  INTEGRATION_NAMES.LUMARY,
];

/**
 * Integrations which rely on the polling request approach, asking for the data update between a certain period of time.
 *
 * All the other integrations rely on event-driven approach which provides real-time data update.
 */
export const POLLING_DRIVEN_INTEGRATIONS = [
  INTEGRATION_NAMES.VIREO,
  INTEGRATION_NAMES.THERAPY_PMS,
  INTEGRATION_NAMES.LUMARY,
];

/**
 * Integrations which use our API/v2 implementation
 */
export const V2_DRIVEN_INTEGRATIONS = [
  INTEGRATION_NAMES.BOOST,
  INTEGRATION_NAMES.CAMBER,
];

export const INTEGRATIONS_LOGOS = {
  [INTEGRATION_NAMES.ALOHA]: 'integrations/logo-aloha.png',
  [INTEGRATION_NAMES.VIREO]: 'integrations/logo-vireo.gif',
  [INTEGRATION_NAMES.LUMARY]: 'integrations/logo-lumary.png',
  [INTEGRATION_NAMES.BOOST]: 'integrations/logo-boost.png',
  [INTEGRATION_NAMES.CAMBER]: 'integrations/logo-camber.png',
  [INTEGRATION_NAMES.THERAPY_PMS]: 'integrations/logo-therapypms.png',
};

export const CANCELLATION_REQUEST_STATUSES = {
  APPROVED: 'approved',
  DENIED: 'denied',
  PENDING: 'pending',
};
